export function getRateCardId(state) {
  const { audienceSizer: { price: { rateCardId = '' } = {} } } = state;
  return rateCardId;
}

export function getPriceData(state) {
  const { audienceSizer: { price = {} } } = state;
  return price;
}



// WEBPACK FOOTER //
// ./src/selectors/audienceSizer.js